import type { AppState } from '../../../store'

export const TeamsModuleSliceKey = 'modules.teams'
export const getTeamsModuleState = (state: AppState) =>
  state[TeamsModuleSliceKey]
